import styled from 'styled-components';
import { AddIcon, DelIcon } from '../icon/icon';
import { ChangeEvent, useState } from 'react';
import { UseFormRegister, UseFormSetValue } from 'react-hook-form';

interface FileUploadProps {
  title: string;
  height?: string;
  name: string;
  errors?: string[];
  register: UseFormRegister<any>;
  setValue: UseFormSetValue<any>;
}

export const FileUploadImg = ({
  title,
  height = 'auto',
  name,
  register,
  setValue,
  errors = [],
}: FileUploadProps) => {
  const [fileName, setFileName] = useState<string>('');
  const [fileUrl, setFileUrl] = useState<string>('');
  const [rotate, setRotate] = useState<boolean>(false);

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const file = files[0];
      setFileName(file.name);
      setFileUrl(URL.createObjectURL(file));
      setRotate(false); // 이미지가 변경될 때 회전 초기화
      setValue(name, file); // useForm에 파일 설정
    }
  };

  const handleRemoveFile = () => {
    setFileName('');
    setFileUrl('');
    setRotate(false);
    setValue(name, null); // 파일 제거 시 useForm의 값도 제거
  };

  const handleImageLoad = (
    event: React.SyntheticEvent<HTMLImageElement, Event>,
  ) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;
    if (naturalHeight > naturalWidth) {
      setRotate(true); // 높이가 너비보다 크면 회전
    }
  };

  return (
    <>
      <FileUpload height={height}>
        {!fileUrl ? (
          <label>
            <div className="icon-box">
              <AddIcon />
            </div>
            <span>{fileName || title}</span>
            <input
              type="file"
              onChange={(e) => {
                handleFileChange(e);
                register(name).onChange(e); // register의 onChange 핸들러 호출
              }}
            />
          </label>
        ) : (
          <ImagePreview aspectRatio="300 / 200">
            <img
              src={fileUrl}
              alt={fileName}
              onLoad={handleImageLoad}
              className={rotate ? 'rotate' : ''}
            />
            <button onClick={handleRemoveFile}>
              <DelIcon />
            </button>
          </ImagePreview>
        )}
      </FileUpload>
      {errors.map((error, index) => (
        <ValTxt key={index}>{error}</ValTxt>
      ))}
    </>
  );
};

// styled components
const FileUpload = styled.div<{ height: string }>`
  width: 100%;
  height: ${(props) => (!props.height ? '10.4rem' : props.height + 'px')};
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05);
  min-height: 10.4rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0.8rem;
  overflow: hidden;
  label {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    .icon-box {
      display: flex;
      margin-bottom: 0.8rem;
    }
    span {
      font-size: 1.3rem;
      font-weight: 500;
      color: ${(props) => props.theme.gray500};
    }
    input[type='file'] {
      display: none;
    }
  }
`;

const ImagePreview = styled.div<{ aspectRatio: string }>`
  max-width: 100%;
  height: 100%;
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    width: 100%;
    height: 100%;
    aspect-ratio: ${(props) => props.aspectRatio}; // 동적으로 aspect-ratio 적용
    object-fit: cover;
    &.rotate {
      transform: rotate(270deg); // 회전 스타일 적용
    }
  }
  button {
    border: 0;
    outline: none;
    display: flex;
    background: none;
    padding: 0;
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
`;

const ValTxt = styled.span`
  width: 100%;
  color: ${(props) => props.theme.errorColor};
  font-size: 1.2rem;
  font-weight: 400;
  display: flex;
  margin: 1rem 1.7rem 0;
`;
